import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect, useRef } from "react";

export default function ConflitoConcorrenciaModal({
  open,
  entity,
  message,
  onReload,
  onClose,
}) {
  const titleRef = useRef(null);

  useEffect(() => {
    if (open) {
      titleRef.current?.focus();
    }
  }, [open]);

  const handleReload = () => {
    if (onReload) onReload();
    else window.location.reload();
  };

  const focusOutline = {
    "&:focus-visible": {
      outline: "2px solid",
      outlineColor: "primary.main",
      outlineOffset: "2px",
    },
  };

  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      aria-labelledby="conflito-titulo"
      aria-modal="true"
      disableAutoFocus
      TransitionProps={{
        onEntered: () => titleRef.current?.focus(),
      }}
    >
      <DialogTitle
        id="conflito-titulo"
        ref={titleRef}
        tabIndex={-1}
        sx={{ outline: "none", color: "error.main" }}
      >
        Conflito de edição
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.primary" }}>
          {message ||
            "Este registro foi atualizado por outro usuário enquanto você editava."}
        </DialogContentText>
        <DialogContentText sx={{ color: "text.primary" }}>
          Suas alterações <strong>não foram salvas</strong>. Recarregue a página
          para ver os dados mais recentes antes de editar novamente.
        </DialogContentText>
        {entity && (
          <DialogContentText sx={{ fontSize: 12, color: "text.secondary" }}>
            Recurso: <code>{entity}</code>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={focusOutline}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleReload} sx={focusOutline}>
          Recarregar página
        </Button>
      </DialogActions>
    </Dialog>
  );
}
